<template>
  <v-container fluid>
    <a-tabs v-model="date" size="small" @change="getdata()">
      <a-tab-pane v-for="item in dates" :key="item" :tab="item"></a-tab-pane>
    </a-tabs>
    <!-- 交接班日志内容 -->
    <v-card tile>
      <a-table size="small" bordered :columns="headers" :data-source="flist" :pagination="false"
        :locale="{ emptyText: '暂无数据' }" row-key="_id">
        <template slot="title">
          <div class="d-flex justify-space-between align-center">
            <span class="text-subtitle-1">
              交接班日志列表（共 {{ list.length }} 条）
            </span>
            <a-space>
              <a-input-search placeholder="搜索内容/提交人" enter-button style="width: 260px" v-model="searchtext" />
              <a-button type="primary" @click="showadd()">
                <a-icon type="plus" /> 新增日志
              </a-button>
            </a-space>
          </div>
        </template>
        <template slot="index" slot-scope="text, record, idx">
          {{ idx + 1 }}
        </template>
        <template slot="action" slot-scope="text, record">
          <a-space>
            <a-button type="link" size="small" @click="showedit(record)">
              <a-icon type="edit" /> 编辑
            </a-button>
            <a-popconfirm title="删除数据" ok-text="确定" cancel-text="取消" @confirm="remove(record._id)">
              <a-button type="link" size="small" style="color:#ff4d4f">
                <a-icon type="delete" /> 删除
              </a-button>
            </a-popconfirm>
          </a-space>
        </template>
      </a-table>
    </v-card>
    <!-- 新增/编辑交接班日志弹窗 -->
    <v-dialog v-model="model" width="450">
      <v-form ref="formRef" v-model="valid" lazy-validation>
        <v-card>
          <v-card-title class="grey lighten-4 pa-2 text-subtitle-1 mb-4 d-flex justify-space-between">
            {{ title }}
            <v-icon @click="() => model = false">mdi-close</v-icon>
          </v-card-title>
          <v-card-text>
            <v-container style="max-height:550px;overflow-y: auto;">
              <v-row>
                <v-col cols="12">
                  <v-textarea v-model="form.content" :rules="[vrules.required]" outlined rows="4" dense>
                    <template v-slot:label>
                      交接班内容<span class="red--text">*</span>
                    </template>
                  </v-textarea>
                </v-col>
                <v-col cols="12">
                  <v-textarea v-model="form.notice" :rules="[vrules.required]" outlined rows="4" dense>
                    <template v-slot:label>
                      注意事项<span class="red--text">*</span>
                    </template>
                  </v-textarea>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn tile color="primary" :disabled="!valid" @click="save">提交</v-btn>
            <v-btn tile @click="() => model = false">取消</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
  </v-container>
</template>
<script>
import _ from "underscore";
import { mapState } from "vuex";
export default {
  name: "DispatchLog",
  data() {
    return {
      date: this.$moment().format('YYYY-MM-DD'),
      dates: [
        this.$moment().add(-3, 'day').format('YYYY-MM-DD'),
        this.$moment().add(-2, 'day').format('YYYY-MM-DD'),
        this.$moment().add(-1, 'day').format('YYYY-MM-DD'),
        this.$moment().add(0, 'day').format('YYYY-MM-DD'),
        this.$moment().add(1, 'day').format('YYYY-MM-DD'),
        this.$moment().add(2, 'day').format('YYYY-MM-DD'),
        this.$moment().add(3, 'day').format('YYYY-MM-DD'),
      ],
      searchtext: '',
      list: [],
      headers: [
        { dataIndex: 'index', scopedSlots: { customRender: 'index' }, width: 60, align: 'center', title: '序号' },
        { dataIndex: 'content', scopedSlots: { customRender: 'content' }, width: 250, align: 'left', title: '交接班内容' },
        { dataIndex: 'notice', scopedSlots: { customRender: 'notice' }, width: 200, align: 'left', title: '注意事项' },
        { dataIndex: 'create_by', scopedSlots: { customRender: 'create_by' }, width: 100, align: 'center', title: '提交人' },
        { dataIndex: 'create_time', scopedSlots: { customRender: 'create_time' }, width: 160, align: 'center', title: '创建时间' },
        { dataIndex: 'action', scopedSlots: { customRender: 'action' }, width: 120, align: 'center', title: '操作' },
      ],
      height: 600,
      vrules: {
        required: (value) => !!value || "不能为空",
      },
      // 交接班日志相关
      model: false,
      title: '',
      form: {},
      valid: true,
    };
  },
  computed: {
    ...mapState(["role", "username"]),
    width() {
      return _.reduce(this.headers, (a, b) => a + (b.width || 300), 0);
    },
    flist() {
      if (!this.searchtext) return this.list;
      return this.logList.filter(item =>
        item.content?.includes(this.searchtext)
        || item.notice?.includes(this.searchtext)
        || item.create_by?.includes(this.searchtext)
      );
    },
  },
  components: {},
  watch: {
  },
  mounted() {
    this.height = window.innerHeight - 300;
    window.onresize = (e) => {
      console.log("onresize", window.innerHeight);
      this.height = window.innerHeight - 300;
    };
  },
  activated() {
    this.dates = [
      this.$moment().add(-3, 'day').format('YYYY-MM-DD'),
      this.$moment().add(-2, 'day').format('YYYY-MM-DD'),
      this.$moment().add(-1, 'day').format('YYYY-MM-DD'),
      this.$moment().add(0, 'day').format('YYYY-MM-DD'),
      this.$moment().add(1, 'day').format('YYYY-MM-DD'),
      this.$moment().add(2, 'day').format('YYYY-MM-DD'),
      this.$moment().add(3, 'day').format('YYYY-MM-DD'),
    ];
    this.getdata();
  },
  methods: {
    init() {
      this.getdata();
    },
    getdata() {
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/dispatchlog/list", { date: this.date }).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          this.list = res.data.list;
        } else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
    showadd() {
      this.form = {
        _id: "",
        content: "",
        notice: "",
      };
      this.title = '新增日志';
      this.model = true;
    },
    showedit(item) {
      this.form = {
        _id: item._id,
        content: item.content,
        notice: item.notice,
      };
      this.title = '编辑日志';
      this.model = true;
    },
    save() {
      if (!this.$refs.formRef.validate()) return;
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/dispatchlog/save", { dataForm: { ...this.form, date: this.date } }).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          this.model = false;
          this.getdata();
        } else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
    remove(_id) {
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/dispatchlog/remove", { _id }).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          this.getdata();
        } else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
  },
};
</script>
<style lang="less" scoped>
p {
  margin: 0;
}
</style>